import React, { forwardRef } from 'react';
import ReactPlayer from 'react-player';
import './VideoPlayer.css';

const VideoPlayer = forwardRef(({ url, onReady, onStateChange, ...props }, ref) => {
  const handleReady = (player) => {
    if (onReady) {
      onReady(player.getInternalPlayer());
    }
  };

  return (
    <div className="video-player-container">
      <ReactPlayer
        ref={ref}
        url={url}
        width="100%"
        height="100%"
        controls={true}
        playing={false}
        light={false}
        pip={true}
        stopOnUnmount={true}
        config={{
          youtube: {
            playerVars: {
              modestbranding: 1,
              rel: 0,
              showinfo: 0,
              iv_load_policy: 3,
              cc_load_policy: 0,
              color: 'white',
              theme: 'dark',
              fs: 1
            }
          }
        }}
        onReady={handleReady}
        onStateChange={onStateChange}
        onError={(e) => console.error('Video Player Error:', e)}
        {...props}
      />
    </div>
  );
});

export default VideoPlayer; 